import gsap from 'gsap';

export const animateDeviceOut = (triggerId: string, deviceId: string) =>
  gsap
    .timeline({ scrollTrigger: { trigger: triggerId, start: '70% top', end: '100% top', scrub: true } })
    .fromTo(deviceId, { yPercent: 0 }, { yPercent: -15 });
